import React from 'react';
import styles from './ComponentLoader.module.scss';

interface ComponentLoaderProps {
  loading?: boolean;
}

const ComponentLoader: React.FC<ComponentLoaderProps> = ({ loading = true }) => {
  if (!loading) return null;

  return (
    <div className={styles.loaderOverlay}>
      <div className={styles.spinner}></div>
    </div>
  );
};

export default ComponentLoader;
